(function () {
	window.addEventListener('DOMContentLoaded', () => {
		// const checkbox_wrap = document.querySelector('.newsletter-modal__checkboxes');
		// const checkbox = document.getElementsByClassName('newsletter-modal__check');
		const checkboxes = document.querySelectorAll('input.newsletter-modal__check');
		// const submit = document.querySelector('button.js-newsletter-form__submit');
			
		checkboxes.forEach(function(curr, index) {
			curr.addEventListener('change', function(event) {
				if (event.currentTarget.checked) {
					curr.value = true;
				} else {
					curr.value = false;
				}
			})
		})
			
		// function allTrue(nodeList) {
		// 	for (var i = 0; i < nodeList.length; i++) {
		// 		if (nodeList[i].checked === false) return false;
		// 	}
		// 	return true;
		// }
			
		// checkbox_wrap.addEventListener('click', function(event) {
		// 	submit.disabled = true;
			
		// 	if (allTrue(checkbox)) {
		// 		submit.disabled = false;
		// 	}
		// });
	})
})()